var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  gap: 15px;\n"], ["\n  display: grid;\n  gap: 15px;\n"])));
export var CustomHelperText = styled('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: red;\n"], ["\n  color: red;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=FreeForm.Styles.js.map